/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { ProviderResourceTypes } from "../operationsInterfaces/index.js";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers.js";
import * as Parameters from "../models/parameters.js";
import { ResourceManagementClient } from "../resourceManagementClient.js";
import {
  ProviderResourceTypesListOptionalParams,
  ProviderResourceTypesListResponse,
} from "../models/index.js";

/** Class containing ProviderResourceTypes operations. */
export class ProviderResourceTypesImpl implements ProviderResourceTypes {
  private readonly client: ResourceManagementClient;

  /**
   * Initialize a new instance of the class ProviderResourceTypes class.
   * @param client Reference to the service client
   */
  constructor(client: ResourceManagementClient) {
    this.client = client;
  }

  /**
   * List the resource types for a specified resource provider.
   * @param resourceProviderNamespace The namespace of the resource provider.
   * @param options The options parameters.
   */
  list(
    resourceProviderNamespace: string,
    options?: ProviderResourceTypesListOptionalParams,
  ): Promise<ProviderResourceTypesListResponse> {
    return this.client.sendOperationRequest(
      { resourceProviderNamespace, options },
      listOperationSpec,
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const listOperationSpec: coreClient.OperationSpec = {
  path: "/subscriptions/{subscriptionId}/providers/{resourceProviderNamespace}/resourceTypes",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ProviderResourceTypeListResult,
    },
    default: {
      bodyMapper: Mappers.CloudError,
    },
  },
  queryParameters: [Parameters.apiVersion, Parameters.expand],
  urlParameters: [
    Parameters.$host,
    Parameters.subscriptionId,
    Parameters.resourceProviderNamespace,
  ],
  headerParameters: [Parameters.accept],
  serializer,
};
